import {Model} from 'vue-mc';

export class UsuarioModel extends Model{
  // Default attributes that define the "empty" state.
  defaults() {
    return {
      clave: undefined
      , username: ""
      , nombre: ""
      , telefono: ""
      , interno: ""
      , celular: ""
      , correoElectronico:""
      , comercio: ""
      , foto: "/static/img/user_thumbnail.jpg"
      , fotoMiniatura: "/static/img/user_thumbnail.jpg"
      , enabled: true
      , activo: true
    }
  }

  // Attribute mutations.
  mutations() {
    return {      
        username:username=>username
      , nombre:nombre=>nombre
      , telefono:telefono=>telefono
      , interno:interno=>interno
      , celular:celular=>celular
      , correoElectronico	:correoElectronico=>correoElectronico
      , comercio: comercio=>comercio
      , enabled:enabled=>enabled
      , activo:activo=>activo
      , foto:foto=>foto
      , foto_miniatura:foto_miniatura=>foto_miniatura
    }
  }

  // Attribute validation
  validation() {
    return {
    }
  }

  // Model Options
  options() {
    return {
      validateOnSave     : false
      , validateOnChange   : false 
      , validateRecursively: false
    }
  }

}


// WEBPACK FOOTER //
// ./src/models/seguridad/usuario.js